module.exports = __webpack_public_path__ + "static/img/GABRIEL_MARTINEZ.bd55c48.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/video-cover/GABRIEL_MARTINEZ.jpg
// module id = +7at
// module chunks = 1